module.exports = __webpack_public_path__ + "img/empty.51acede6.png";